
// "Did you mean…?" strip shown inside the manual medication form (add and
// edit), offering to resolve a hand-typed name to a real Oracle drug.
//
// Why it exists: flow only sends drugs WITH an rxcui to Oracle when it quotes
// (flow/consults/endpoints/quotes.py — `drugs=[d for d in user.drugs if ... and
// d.get("rxcui")]`), so a manual entry is stored and shown to the advisor but
// contributes nothing to plan scoring, formulary/tier checks, the estimated
// drug spend or the cheapest-pharmacy pick. Clients reach the manual form when
// the main search came back empty — very often because Oracle was slow or
// briefly down, not because the drug is genuinely unlisted — so re-checking
// the name they typed here recovers a real, priceable rxcui most of the time.
//
// Purely an offer, never a gate: with no matches the manual form behaves
// exactly as it did before, and "Add" stays available even when matches ARE
// showing (a compounded prescription or a supplement legitimately has no
// rxcui, and refusing to store it would be worse than storing it unpriced).
export default {
    props: {
        // Raw $api.searchDrugs hits — the parent caps the count.
        matches: { type: Array, required: true },
        // The typed name these matches came from, echoed back so it's obvious
        // what was searched.
        query: { type: String, default: '' },
        // rxcuis already on the client's list. A drug added twice is counted
        // twice in the Part D estimate, so those rows are shown but disabled —
        // same guard (and same "Added" affordance) as the main search results
        // in MedicationsStep.vue.
        addedRxcuis: { type: Array, default: () => [] },
    },
    methods: {
        // Mirrors MedicationsStep's resultMeta() so a suggestion row reads
        // identically to the search-dropdown row for the same drug.
        metaFor (m) {
            if (m.generic && m.generic.name) { return m.generic.name }
            if (m.is_generic) { return 'Generic' }
            return null
        },
    },
}
